<template>
  <div class="centerWidth">
    <div class="tag_position d-flex d-align-center">
      <img src="../assets/images/add1.png" alt="">
      当前位置：<a href="/">首页</a>&gt; <span>课程详情</span>
    </div>
    <div class="detail-wrap">
      <div class="tit">{{ name }}</div>
      <!--      <div class="d-flex d-just-end">-->
      <!--        <el-button>去考试</el-button>-->
      <!--      </div>-->
      <div class="tabs-container">
        <!-- Tab Header -->
        <div class="tab-header">
          <div
              v-for="(tab, index) in tabs"
              :key="index"
              @click="selectTab(index)"
              :class="['tab-item', { active: selectedIndex === index }]"
          >
            {{ tab.title }}
          </div>
          <div class="underline" :style="{ transform: underlineTransform }"></div>
        </div>

        <transition name="fade" mode="out-in">
          <div class="tab-content" :key="selectedIndex">
            <template v-if="selectedIndex == 0">
              <table border="1" class="dagang">
                <tr>
                  <th>培训内容</th>
                  <th>学时</th>
                </tr>
                <tr v-for="(item,index) in allList" :key="index">
                  <td>{{ item.name }}</td>
                  <td v-if="index == 0" :rowspan="allList.length">{{ studytime }}</td>
                </tr>
              </table>
            </template>
            <template v-if="selectedIndex == 1">
                <div class="bookrec-box">
                  <div class="bookrec-item" v-for="(item,index) in kcList" :key="index">
                    <a :href="item1.url" target="_blank" v-for="(item1,index1) in item" :key="index1">
                      <img :src="item1.img">
                    </a>
                </div>
              </div>
            </template>
            <template v-if="selectedIndex == 2">
              <div class="card-body">
                <div class="ci-item" v-for="(item,index) in videoList" :key="index">
                  <div class="left">
                    <i class="el-icon-video-play"></i>
                    <a>{{ item.name }}</a>
                  </div>
                  <div class="ci-tools">
                    <!--                    <a class="time">46 分钟</a>-->
                    <a class="lock">
                      <span class="el-tag el-tag--light" @click="toView(item)">立即学习</span>
                    </a>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </transition>
      </div>
    </div>


    <el-dialog
        title="音视频"
        :visible.sync="dialogVisible"
        width="60%">
      <div class="view-wrap" v-if="ifAudia">
        <audio controls>
          <source :src="url" type="audio/mpeg">
        </audio>
      </div>
      <div class="view-wrap" v-if="!ifAudia">
        <video :src="url" controls></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getcoursedetail,
  item_lists,
  item_detail,
  get_book_lists
} from "@/api/index";

export default {
  name: "courseList",
  data() {
    return {
      id: '',
      name: '',
      selectedIndex: 0,
      tabs: [
        {title: '课程大纲'},
        {title: '在线课程'},
        {title: '在线视频'},
      ],
      studytime: '',
      allList: [],
      videoList: [],
      kcList: [],
      dialogVisible: false,
      ifAudia: false,
      url: ''
    }
  },
  computed: {
    underlineTransform() {
      const width = 100 / this.tabs.length;
      return `translateX(${this.selectedIndex * 33.333333333}%) scaleX(${width}%)`;
    }
  },
  mounted() {
    let info = JSON.parse(this.$route.query.info)
    this.id = info.id
    this.name = info.name
    this.getDetails()
    this.getDetails1()
    this.getDetails2()
  },
  methods: {
    selectTab(index) {
      this.selectedIndex = index;
    },
    getDetails() {
      getcoursedetail({id: this.id}).then(res => {
        if (res.code == 1) {
          this.allList = res.data[0].detail
          this.studytime = res.data[0].studytime
          // console.log(allList)
        }
      })
    },
    getDetails1() {
      item_detail({id: this.id}).then(res => {
        if (res.code == 1) {
          this.videoList = res.data
        }
      })
    },
    getDetails2() {
      get_book_lists({subject_id: this.id}).then(res => {
        if (res.code == 1) {
          this.kcList = this.chunkList(res.data,5)
        }
      })
    },
    chunkList(list, size = 5) {
      const result = [];

      for (let i = 0; i < list.length; i += size) {
        result.push(list.slice(i, i + size));
      }

      return result;
    },
    currentChange() {

    },
    toKc(id) {
      this.$router.push({
        path: '/courseDetail',
        query: {id}
      })
    },
    toView(item) {
      let ifAudia = this.isAudioFile(item.url)
      this.ifAudia = ifAudia
      this.url = item.url
      this.dialogVisible = true
    },
    isAudioFile(url) {
      if (!url) return false;

      const extension = url.split('.').pop().toLowerCase();
      const audioExtensions = ['mp3', 'wav', 'ogg', 'flac', 'aac', 'm4a', 'wma'];

      return audioExtensions.includes(extension);
    }
  }
}
</script>

<style scoped lang="scss">
.detail-wrap {
  margin-top: 30px;
  margin-bottom: 50px;

  .tit {
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    background-image: url("../assets/images/title.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    height: 100px;
    width: 700px;
    line-height: 100px;
    margin: 0 auto;
    color: #ffffff;
    letter-spacing: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .tabs {
    width: 80%;
    max-width: 600px;
  }

  .tabs-container {
    width: 100%;
    margin: 50px auto 30px auto;
    background: #fff;
    border-radius: 12px;
    box-sizing: border-box;
  }

  .tab-header {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    overflow: hidden;
    border-bottom: 2px solid transparent;
    background: #f7f8fa;
    margin: 0 auto;
  }

  .tab-item {
    flex: 1;
    text-align: center;
    padding: 16px 0;
    cursor: pointer;
    font-size: 1.1rem;
    font-weight: 600;
    color: #444;
    transition: all 0.3s ease;
    z-index: 1;
    transform: scale(1);
  }

  .tab-item:hover {
    color: #2257ab;
    transform: scale(1.05);
  }

  .tab-item.active {
    //color: #2257ab;
    transform: scale(1);
    background: rgba(0, 123, 255, .8);
    color: #ffffff;
  }

  /* 下划线动画 */
  .underline {
    position: absolute;
    bottom: -2px;
    left: 0;
    height: 4px;
    width: 100%;
    background: linear-gradient(90deg, #00c9ff, #92fe9d);
    transform-origin: left;
    transition: transform 0.5s cubic-bezier(0.645, 0.045, 0.355, 1);
    z-index: 0;
  }

  /* 内容区域样式 */
  .tab-content {
    margin-top: 30px;
    font-size: 1rem;
    color: #333;
  }

  /* 过渡动画 */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.4s ease;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .dagang {
    width: 100%;
    margin: 0 auto;
    border-radius: 5px;

    tr {
      height: 56px;

      th {
        color: #333;
        font-weight: bold;
        font-size: 18px;
      }

      td:nth-child(1) {
        padding-left: 20px;
      }

      td:nth-child(2) {
        text-align: center;
        font-size: 20px;
      }
    }
  }

  .card-body {
    border: 1px solid #ebecf2;
    border-radius: 10px;
    margin: 0 0 15px;
    position: relative;
    padding: 5px 30px;

    .ci-item {
      padding-bottom: 20px;
      padding-top: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #e8e8e8;

      &:last-child {
        border-bottom: 0;
      }

      .left {
        display: flex;
        align-items: center;

        i {
          color: #2257ab;
          font-size: 24px;
          margin-right: 10px;
        }

        a {
          font-size: 30px;
        }
      }

      .ci-tools {
        display: flex;
        align-items: center;

        .time {
          margin-right: 10px;
        }

        .lock {
          cursor: pointer;
        }
      }
    }
  }
}

.view-wrap {
  width: 100%;
  height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;

  video {
    width: 100%;
    height: 100%;
  }
}

.bookrec-box {
  padding-top: 10px;
  padding-bottom: 20px;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  min-height: 240px;
  .bookrec-item {
    height: 200px;
    margin-top: 40px;
    display: flex;
    background: url(../assets/images/bookrec.png) no-repeat bottom center;
    background-size: 100%;

    a {
      width: 140px;
      height: 200px;
      display: inline-block;

      &:nth-child(1) {
        margin-left: 75px;
      }

      &:nth-child(2) {
        margin-left: 90px;
      }

      &:nth-child(3) {
        margin-left: 90px;
      }

      &:nth-child(4) {
        margin-left: 90px;
      }

      &:nth-child(5) {
        margin-left: 75px;
      }

      img {
        width: 140px;
        height: 200px;
        object-fit: cover;
        position: relative;
        z-index: 10;
        background-color: white;
        top: -25px;
      }
    }
  }
}
</style>
